/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schoolinformation1Inputs */

const de__field_schoolinformation1 = /** @type {(inputs: _Field_Schoolinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schulinformationen`)
};

/**

* @param {_Field_Schoolinformation1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schoolinformation1 = /** @type {((inputs?: _Field_Schoolinformation1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schoolinformation1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schoolinformation1(inputs)
});
export { _field_schoolinformation1 as "_field_schoolInformation" }